import { render, staticRenderFns } from "./SubtasksList.vue?vue&type=template&id=55df82b8&scoped=true"
import script from "./SubtasksList.vue?vue&type=script&lang=js"
export * from "./SubtasksList.vue?vue&type=script&lang=js"
import style0 from "./SubtasksList.vue?vue&type=style&index=0&id=55df82b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df82b8",
  null
  
)

export default component.exports